export const Theme = {
    bg:"#89a999",
    bgLight: "#a6abbf",
    primary:"#577acb",
    text_primary:"#F2F3F4",
    text_secondary:"rgba(223, 223, 225, 0.69)",
    card:"#2c2c2dcb",
    card_light: '#494969',
    button:"#577acb",
    white:"#FFFFFF",
    black:"#000000",
}